var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "complainant_info" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "250px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: "企业名称：", prop: "businessName" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.entName
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: "统一社会信用代码：", prop: "complaintNumber" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.legalCode
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: {
                label: "企业法定代表人：",
                prop: "corporateRepresentative",
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.legalAgentor
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: {
                label: "法定代表人身份证号码：",
                prop: "corporateRepresentativeCode",
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.legalAgentorCode
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 投诉人：", prop: "complainants" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.complainter
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 投诉人联系方式：", prop: "complainantsPhone" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.complainterPhone
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 投诉人身份证号码：", prop: "complainantsCard" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.complainterCode
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 投诉人邮箱：", prop: "complainantsPhone" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.complainterEmail
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 投诉受理部门：", prop: "complainantsPhone" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.receiverOrgName
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: { label: " 投诉人地址：", prop: "complainantsAddress" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.complainterAddress
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: { label: " 投诉渠道：", prop: "complainantChannels" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintFounderVo &&
                      _vm.ruleForm.complaintFounderVo.sourceTypeName
                  )
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }